import { Flex } from '@chakra-ui/react';
import { NestedMunicipality } from '@habity/types';
import { Link } from '@chakra-ui/next-js';
import { MunicipalityImageCard } from './components/MunicipalityImageCard';
import { MunicipalityCardData } from './components/MunicipalityCardData';

interface MunicipalityCardProps {
  municipality: NestedMunicipality;
  href: string;
  isLoading?: boolean;
  variant?: 'default' | 'compact';
}

export const MunicipalityCard = ({
  municipality,
  isLoading = false,
  href,
  variant = 'default',
}: MunicipalityCardProps) => {
  // Create the card content
  const cardContent = (
    <Flex
      overflow="hidden"
      flexDirection={variant === 'compact' ? 'row' : 'column'}
      flexGrow={{ base: 0, sm: 1 }}
      justifyContent="flex-start"
      gap="1"
      minW="260px"
      cursor={isLoading ? 'default' : 'pointer'}
      border="none"
      className="group"
    >
      <MunicipalityImageCard
        municipality={municipality}
        aspectRatio={1 / 1.2}
        borderTopRadius="4px"
        borderBottomRadius="4px"
        boxProps={{ cursor: isLoading ? 'default' : 'pointer' }}
        isLoading={isLoading}
        spacing={variant === 'compact' ? 'compact' : 'default'}
      />
      <MunicipalityCardData
        municipality={municipality}
        isLoading={isLoading}
        variant={variant}
      />
    </Flex>
  );

  // If loading, don't wrap with Link to make it not clickable
  if (isLoading) {
    return cardContent;
  }

  // Otherwise, wrap with Link for navigation
  return (
    <Link
      href={href}
      _hover={{ textDecoration: 'none' }}
      onClick={(e) => {
        // Check if the click is on or inside a button element
        const target = e.target as HTMLElement;
        if (target.closest('button')) {
          e.preventDefault();
          return;
        }
      }}
    >
      {cardContent}
    </Link>
  );
};
